import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[fileDragDrop]',
  standalone: true
})
export class FileDragDropDirective {
  @Output() filesChangeEmiter = new EventEmitter<FileList>();

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.addDragOverStyles(event.target as HTMLElement);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.removeDragOverStyles(event.target as HTMLElement);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.removeDragOverStyles(event.target as HTMLElement);
    
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      this.filesChangeEmiter.emit(event.dataTransfer.files);
    }
  }

  private addDragOverStyles(element: HTMLElement): void {
    if (element) {
      element.style.border = '2px dashed #007bff';
      element.style.backgroundColor = '#f8f9fa';
    }
  }

  private removeDragOverStyles(element: HTMLElement): void {
    if (element) {
      element.style.border = '';
      element.style.backgroundColor = '';
    }
  }
}